module.exports = __webpack_public_path__ + "img/HTML.a2d427be.svg";